import React, { Component } from "react";
import PodaciORegRevizoraUtrecojZemlji from "../PodaciORegRevizoraUtrecojZemlji/PodaciORegRevizoraUtrecojZemlji";
import RegSubjZaObavljanjeRevUTrecojZemlji from "../RegSubjZaObavljanjeRevUTrecojZemlji/RegSubjZaObavljanjeRevUTrecojZemlji";
import { SolutionOutlined, FormOutlined } from "@ant-design/icons";
import { Steps } from "antd";
import axiosInstance from "../../api/utils/axiosInstance";
import { connect } from "react-redux";
import {
  formSubmitError,
  formSubmitSuccess,
} from "../../store/actions/forms/formActions";

const steps = [
  {
    title: "Registar subjekata za obavljanje revizije u trećoj zemlji",
    content: "Second-content",
    icon: <SolutionOutlined />,
  },
  {
    title: "Registar revizora u trećoj zemlji",
    content: "Last-content",
    icon: <FormOutlined />,
  },
];
const { Step } = Steps;

class RegistarSubjekataRevizoraUtrecojZemlji extends Component {
  state = {
    registarSubjekata: [],
    registarRevizora: [],
    steps: {
      current: 0,
    },
    azuriranjeSubjekata: [],
    azuriranjeRevizora: [],
    update: false,
    renderChild: false,
    loader: false,
  };

  componentDidMount = async () => {
    const updatePage = this.props.match.url.includes("/azuriraj");

    if (updatePage) {
      const { idDrustva, vrDrustva } = this.props;

      const { data } = await axiosInstance.get(
        `/findDrustvo?idDrustva=${idDrustva}&vrDrustva=${vrDrustva}&showHistory=false`
      );

      const filteredDataSubjekt = data.filter((element, index) => {
        return index < 11;
      });

      const filteredDataRevizor = data.filter((element, index) => {
        return index > 10;
      });

      this.setState({
        azuriranjeSubjekata: filteredDataSubjekt,
        azuriranjeRevizora: filteredDataRevizor,
        update: true,
        renderChild: true,
      });
      return;
    }
    this.setState({ renderChild: true });
  };

  next = () => {
    this.setState((prevState) => ({
      steps: {
        ...prevState.steps,
        current: prevState.steps.current + 1,
      },
    }));
  };

  submitRegistarSubjekata = (submitData) => {
    this.setState(
      {
        registarSubjekata: submitData,
      },
      () => {
        this.next();
      }
    );
  };

  submitRegistarRevizora = (submitData) => {
    this.setState(
      {
        registarRevizora: submitData,
      },
      () => {
        this.submitHandler();
      }
    );
  };

  submitHandler = async () => {
    const { zahtjevAtrId } = this.props;
    const { registarSubjekata, registarRevizora, update } = this.state;
    const submitData = [...registarSubjekata];
    submitData.push(...registarRevizora);

    try {
      this.setState({
        loader: true,
      });
      if (update) {
        const res = await axiosInstance.patch("/edit", submitData).then(() =>
          this.setState({
            loader: false,
          })
        );
        this.props.formSubmitSuccess(false, "Podaci uspješno ažurirani.");

        this.props.history.push("/pregled-registara");
        return;
      }

      const res = await axiosInstance
        .post(`/unos/${zahtjevAtrId}`, submitData)
        .then(() =>
          this.setState({
            loader: false,
          })
        );
      this.props.formSubmitSuccess(
        false,
        "Podaci o subjektu uspješno upisani."
      );
      this.props.history.push("/pregled-registara");
    } catch (e) {
      this.props.formSubmitError(
        true,
        e.response.data.message ||
          "Nešto je pošlo po krivu, provjerite unesene podatke!"
      );
      this.setState({
        loader: false,
      });
    }
  };

  render() {
    const { current } = this.state.steps;
    const { renderChild } = this.state;
    return (
      <div>
        {renderChild && (
          <>
            <Steps current={current}>
              {steps.map((item) => (
                <Step icon={item.icon} key={item.title} title={item.title} />
              ))}
            </Steps>
            {current == 0 && (
              <RegSubjZaObavljanjeRevUTrecojZemlji
                azuriranjeSubjekata={this.state.azuriranjeSubjekata}
                submitRegistarSubjekata={this.submitRegistarSubjekata}
              />
            )}
            {current == 1 && (
              <PodaciORegRevizoraUtrecojZemlji
                azuriranjeRevizora={this.state.azuriranjeRevizora}
                submitRegistarRevizora={this.submitRegistarRevizora}
                loader={this.state.loader}
              />
            )}
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zahtjevAtrId: state.formData.zahtjevAtrId,
    idDrustva: state.update.idDrustva,
    vrDrustva: state.update.vrDrustva,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistarSubjekataRevizoraUtrecojZemlji);
